// Global Components
import * as React from 'react';

// Types
import type {
  $InputProps,
} from '../../../types';

type $OptionalProps = {
  required?: boolean;
  type?: 'checkbox' | 'email' | 'text';
  value?: boolean | null | number | string;
};

type $Props = $InputProps & $OptionalProps & {
  name: string;
};

const InputHiddenView = function ({
  name,
  required,
  type,
  value,
}: $Props) {
  return (
    <input
      className={'hidden'}
      id={name}
      name={name}
      readOnly
      required={required}
      type={type || 'text'}
      value={value as string}
    />
  );
};

InputHiddenView.defaultProps = {
  required: undefined,
  type: undefined,
  value: undefined,
};

export default InputHiddenView;
